import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { faTree } from "@fortawesome/free-solid-svg-icons";
import { faGift } from '@fortawesome/free-solid-svg-icons'
import '../assets/styles/Expertise.scss';

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>heading</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faHouse} size="3x"/>
                    <h3>Interior Decor</h3>
                    <p>Transform your home into a haven of comfort and style with our expert interior décor services. Whether you’re looking to refresh a single room or completely redesign your entire living space, we specialize in creating environments that reflect your unique personality and lifestyle. From selecting the perfect color palettes and textiles to curating artful accessories, we take pride in every detail—ensuring an interior that not only looks exceptional but feels warm and welcoming for years to come.</p>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faTree} size="3x"/>
                    <h3>Exterior Decor</h3>
                    <p>Don’t let your home’s exterior go unnoticed. Our team brings creativity and expertise outdoors, crafting visually stunning landscapes, patios, and entryways that make a lasting impression. We blend practicality with design flair, enhancing curb appeal while weaving in elements that align with your personal tastes and the natural surroundings. Whether it’s updating outdoor furnishings, choosing the right plants, or installing eye-catching lighting, we believe your exterior should be every bit as inviting as the interior.</p>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faGift} size="3x"/>
                    <h3>Gifts & Special Occasions</h3>
                    <p>Celebrate the seasons and every special occasion with our comprehensive holiday décor and gift solutions. We expertly design festive layouts for events both big and small—whether it’s a cozy holiday get-together or a milestone celebration. Our curated selection of gifts adds a personal touch, making it simple to find something truly meaningful for loved ones or clients. With our attention to detail and taste for timeless style, you can focus on enjoying the festivities while we handle the décor and gifting arrangements.</p>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;